module.exports = __webpack_public_path__ + "static/media/screwdriver.c2839199.svg";